function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import position from 'polished/lib/shorthands/position';
import math from 'polished/lib/math/math';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var ALL_BORDER_SIZE = '2px';
var useStyles = _ref => {
  var {
    disabled,
    focusVisible,
    maxWidth,
    mainTheme,
    tagBehavior
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var margins = {
      bothProps: "0 ".concat(theme.layout.size1),
      clearButton: "0 ".concat(theme.layout.size1, " 0 ").concat(theme.layout.size2),
      none: "0 ".concat(theme.layout.size2),
      leadingIcon: "0 ".concat(theme.layout.size2, " 0 ").concat(theme.layout.size1)
    };
    return {
      root: _objectSpread({
        alignItems: 'center',
        boxSizing: 'border-box',
        backgroundColor: mainTheme.background,
        border: "1px solid ".concat(mainTheme.borderColor),
        borderRadius: math("".concat(theme.borderRadius5, " + ").concat(theme.borderRadius4)),
        color: mainTheme.foreground,
        display: 'inline-flex',
        height: theme.layout.size6,
        maxWidth
      }, highContrastMediaQuery(theme)),
      label: {
        margin: margins[tagBehavior],
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      leadingIcon: {
        color: 'inherit',
        fill: 'currentcolor',
        margin: "0 0 0 ".concat(theme.layout.size2),
        maxWidth: theme.layout.size4,
        minWidth: theme.layout.size4
      },
      clearButton: _objectSpread({
        borderRadius: theme.borderRadius4,
        display: 'flex',
        marginRight: theme.layout.size1,
        padding: math("".concat(theme.layout.size1, " - ").concat(ALL_BORDER_SIZE)),
        position: 'relative',
        transition: '0.2s'
      }, !disabled && {
        cursor: 'pointer',
        '&:hover': {
          '> svg': {
            fill: mainTheme.clearButtonHover
          },
          backgroundColor: mainTheme.hover
        },
        '&:active': {
          '> svg': {
            fill: mainTheme.clearButtonActive
          },
          backgroundColor: mainTheme.active
        }
      }),
      clearIcon: {
        fill: disabled ? theme.palette.foreground.disabled : mainTheme.clearIcon,
        maxWidth: theme.layout.size3,
        minWidth: theme.layout.size3
      },
      focus: {
        display: 'flex',
        '&::after': _objectSpread(_objectSpread({}, position('absolute', '-3px')), {}, {
          border: "1px solid ".concat(mainTheme.foreground),
          borderRadius: 12,
          opacity: 0,
          transition: 'all 50ms'
        }, focusVisible && _objectSpread(_objectSpread({
          content: "' '"
        }, position('0px')), {}, {
          borderRadius: "calc(12px + 2px)",
          opacity: 1
        }))
      },
      disabled: {
        backgroundColor: theme.palette.background.disabled,
        color: theme.palette.foreground.disabled
      }
    };
  }, [disabled, focusVisible, mainTheme, maxWidth, tagBehavior, theme]);
};
export default useStyles;